import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

// Transparently refresh an expired access token on 401 and retry once.
const NO_REFRESH = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"];
let refreshPromise = null;

api.interceptors.response.use(
    (res) => res,
    async (error) => {
        const original = error.config;
        const url = original?.url || "";
        const status = error.response?.status;
        const skip = NO_REFRESH.some((p) => url.includes(p));

        if (status === 401 && original && !original._retried && !skip) {
            original._retried = true;
            try {
                if (!refreshPromise) {
                    refreshPromise = api.post("/auth/refresh").finally(() => { refreshPromise = null; });
                }
                await refreshPromise;
                return api(original);
            } catch (e) {
                window.dispatchEvent(new Event("ares:session-expired"));
                return Promise.reject(error);
            }
        }
        return Promise.reject(error);
    }
);

export default api;
